var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-724 -626)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(724 626)",
    fill: "none",
    stroke: "#00a85b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(736 638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.035,16.526a.5.5,0,0,1-.348-.147L11.67,12.363a7.053,7.053,0,1,1,.7-.7l4.017,4.016a.495.495,0,0,1-.348.843ZM7.044.989A6.059,6.059,0,1,0,13.1,7.046,6.064,6.064,0,0,0,7.044.989Z",
    transform: "translate(0 0)",
    fill: "#00a85b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5a7b9c967eac448c274ae931aaf49442.svg";
export { ForwardRef as ReactComponent };